export const buildingRoutes = {
  list: "",
  new: "new",
  edit: ":id/edit",
} as const;
